import React from "react";
import MapRouteSidebar from "../components/MapRouteSidebar";
import AllMeasurements from "../components/AllMeasurements";
import { useToolbarState } from "../contexts/ToolbarStateContext";
import { useData } from "../contexts/DataContext";

// this route only is shown / operates in editing mode
const EditRoute = () => {
  const { selectedMode } = useToolbarState();
  const { surfaceFeatures, surfaceTypes } = useData();

  return (
    <>
      <MapRouteSidebar noLink={true} title="Measurements">
        <>
          {!selectedMode && surfaceFeatures.length === 0 && (
            <div>
              To setup a site map, use the toolbar to the right. Click to begin
              drawing the desired item.
            </div>
          )}
          {!selectedMode && surfaceFeatures.length > 0 && (
            <AllMeasurements
              surfaceFeatures={surfaceFeatures}
              surfaceTypes={surfaceTypes}
            />
          )}
          {selectedMode === "arrow" && (
            <div>
              To draw an arrow, click to add points for the arrow. Double-click
              to finish.
            </div>
          )}
          {selectedMode === "hazard" && (
            <div>To add a hazard, click to add it where desired</div>
          )}
          {selectedMode === "surface" && (
            <div>
              To draw a surface, click to add points. Double-click to finish.
            </div>
          )}
          {selectedMode === "text" && (
            <div>To add a text label, click to add it where desired</div>
          )}
        </>
      </MapRouteSidebar>
    </>
  );
};

export default EditRoute;
